import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ allowedRole, children }) {
  const { user } = useAuthUser() || {};
  const location = useLocation();
  const isAuthenticated = useIsAuthenticated();
  const userRole = user?.role || "";
  const allowedRoles = Array.isArray(allowedRole) ? allowedRole : [allowedRole];

  if (!isAuthenticated) {
    return <Navigate to={"/sign-in"} state={{ from: location }} replace />;
  }

  if (isAuthenticated && allowedRoles.includes(userRole)) {
    return children;
  }

  return <Navigate to="/unauthorized" state={{ from: location }} replace />;
}
